import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Box, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Avatar, Menu, MenuItem } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useLocation, useHistory } from "react-router-dom";

function SubTopicPage() {
    const { mainTopic, subTopicType, subtopic } = useParams();
    const [posts, setPosts] = useState([]);

    // State for dialog
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const history = useHistory();

    const [loggedInUser, setLoggedInUser] = useState(null);

    const [cursor, setCursor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        axios.get("/user/me")
            .then(res => setLoggedInUser(res.data))
            .catch(() => setLoggedInUser(null));
    }, []);

    /*
    useEffect(() => {
        axios.get(`/api/subtopic/${subtopic}`)
            .then((res) => setPosts(res.data))
            .catch((err) => console.error(err));
    }, [subtopic]);
    */

    /*
   useEffect(() => {
        axios.get(`/api/subtopic/${mainTopic}/${subTopicType}/${subtopic}`)
            .then((res) => setPosts(res.data))
            .catch((err) => console.error(err));
    }, [mainTopic, subTopicType, subtopic]);
    */
   /*
   useEffect(() => {
        axios
            .get(`/api/subtopic/${mainTopic}/${subTopicType}/${subtopic}/posts?sort=${sortBy}`)
            .then((res) => setPosts(res.data))
            .catch((err) => console.error(err));
    }, [mainTopic, subTopicType, subtopic, sortBy]);
    */

    let topicType = "university";
    // Handle post submission
    /*const handleSubmit = async () => {
        try {
            await axios.post('/api/create-subtopic-post', {
                mainTopic: decodeURIComponent(mainTopic),
                subTopicType,
                subtopic: decodeURIComponent(subtopic),
                title,
                content,
                topicType
            });

            // Close dialog and reset fields
            setOpen(false);
            setTitle('');
            setContent('');

            // Refresh posts after submitting
            //const res = await axios.get(`/api/subtopic/${subtopic}`);
            const res = await axios.get(`/api/subtopic/${mainTopic}/${subTopicType}/${subtopic}/posts`);
            setPosts(res.data);

            //alert('Post created!');
        } catch (err) {
            console.error('Failed to create post', err);
        }
    };*/
    const handleSubmit = async () => {
        if (!content.trim()) return;

        try {
            const res = await axios.post('/api/create-subtopic-post', {
                mainTopic: decodeURIComponent(mainTopic),
                subTopicType,
                subtopic: decodeURIComponent(subtopic),
                title,
                content,
                topicType
            });

            const newCreatedPost = res.data;

            // prepend like your working version
            setPosts(prev => [newCreatedPost, ...prev]);

            // reset pagination chain (IMPORTANT)
            setCursor(null);
            setHasMore(true);

            // UI reset
            setOpen(false);
            setTitle('');
            setContent('');

        } catch (err) {
            console.error('Failed to create post', err);
        }
    };

    const toggleVote = async (postId) => {
        try {
            const res = await axios.post(`/post/${postId}/upvote`);
            setPosts(prev =>
                prev.map(p =>
                    p._id === postId
                    ? { ...p, upvotes: res.data.upvotes, voted: res.data.voted }
                    : p
                )
            );
        } catch (err) {
            console.error("Vote error", err);
        }
    };

    const handleAddComment = async (postId, commentText) => {
        if (!commentText.trim()) return;

        try {
            const res = await axios.post(`/post/${postId}/comment`, { text: commentText });
            setPosts(prev =>
            prev.map(p =>
                p._id === postId
                ? { ...p, comments: res.data, newComment: "" }
                : p
            )
            );
        } catch (err) {
            console.error("Failed to add comment", err);
        }
    };

    const joinVideoCall = async (postId) => {
        try {
            const res = await axios.post(`/post/${postId}/video-room`);
            const roomUrl = res.data.url;
            window.open(roomUrl, "_blank");
        } catch (err) {
            console.error("Failed to join video call", err);
            alert("Could not join video call.");
        }
    };

    let universityLogo = null;

    if (mainTopic.toLowerCase() === "ucla") {
        universityLogo = "/uploads/universityLogos/logo_UCLA_blue_boxed.png";
    } else if (mainTopic.toLowerCase() === "stanford") {
        universityLogo = "/uploads/universityLogos/stanford_logo.png";
    } 

    const defaultLabel = `Recent ${decodeURIComponent(mainTopic)}/${decodeURIComponent(subtopic)}`;
    const [menuLabel, setMenuLabel] = useState(defaultLabel);

    const [anchorEl, setAnchorEl] = useState(null);
    const [sortBy, setSortBy] = useState("recent"); 

    /*useEffect(() => {
        axios
            .get(`/api/subtopic/${mainTopic}/${subTopicType}/${subtopic}/posts?sort=${sortBy}`)
            .then((res) => setPosts(res.data))
            .catch((err) => console.error(err));
    }, [mainTopic, subTopicType, subtopic, sortBy]);*/
    /*const fetchPosts = async (reset = false) => {
        if (loading || (!hasMore && !reset)) return;

        try {
            setLoading(true);

            const res = await axios.get(
            `/api/subtopic/${mainTopic}/${subTopicType}/${subtopic}/posts`,
            {
                params: {
                    sort: sortBy,
                    cursor: reset ? null : cursor,
                    limit: 10
                }
            }
            );

            setPosts(prev =>
                reset ? res.data.posts : [...prev, ...res.data.posts]
            );

            setCursor(res.data.nextCursor);
            setHasMore(res.data.hasMore);

        } catch (err) {
            console.error("Error loading posts", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setPosts([]);
        setCursor(null);
        setHasMore(true);
        fetchPosts(true);
    }, [mainTopic, subTopicType, subtopic, sortBy]);

    const observer = useRef();

    const lastPostRef = useCallback(node => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                fetchPosts();
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore]);*/
     const handleMenuClose = (selectedLabel, sortType) => {
        setAnchorEl(null);
        if (selectedLabel) setMenuLabel(selectedLabel);
        if (sortType) {
            setSortBy(sortType);
            setPosts([]);       // clear previous posts
            setCursor(null);    // reset cursor
            setHasMore(true);   // allow fetching first page
        }
    };

    const fetchPosts = async (overrideCursor = cursor) => {
        if (loading || !hasMore) return;

        try {
            setLoading(true);

            const res = await axios.get(`/api/subtopic/${mainTopic}/${subTopicType}/${subtopic}/posts`, {
                params: {
                    cursor: overrideCursor,
                    limit: 10,
                    sort: sortBy
                }
            });

            const newPosts = Array.isArray(res.data.posts) ? res.data.posts : [];

            setPosts(prev => {
                // prevent duplicates (IMPORTANT for race conditions)
                const ids = new Set(prev.map(p => p._id));
                const filtered = newPosts.filter(p => !ids.has(p._id));
                return [...prev, ...filtered];
            });

            setCursor(res.data.nextCursor);
            setHasMore(res.data.hasMore);

        } catch (err) {
            console.error("Error loading posts", err);
        } finally {
            setLoading(false);
        }
    };

    // RESET when topic/sort changes
    useEffect(() => {
        setPosts([]);
        setCursor(null);
        setHasMore(true);
    }, [mainTopic, subTopicType, subtopic, sortBy]);

    // FETCH when cursor changes (or initial load)
    useEffect(() => {
        fetchPosts();
    }, [cursor, mainTopic, subTopicType, subtopic, sortBy]);

    useEffect(() => {
        if (cursor === null && hasMore) {
            fetchPosts(null); // explicitly pass null
        }
    }, [cursor, hasMore, mainTopic, subTopicType, subtopic, sortBy]);

    const observer = useRef();

    const lastPostRef = useCallback(node => {
        if (loading) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                fetchPosts(); // now safe
            }
        });

        if (node) observer.current.observe(node);
    }, [loading, hasMore, fetchPosts]); 

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    /*const handleMenuClose = (selectedLabel, sortType) => {
        setAnchorEl(null);
        if (selectedLabel) setMenuLabel(selectedLabel);
        if (sortType) setSortBy(sortType);
    };*/

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const topicName = `${mainTopic}/${subTopicType}/${subtopic}`;
    const isJoined = loggedInUser?.joinedSubtopics?.includes(topicName);

    const toggleJoinSubtopic = async () => {
        if (!loggedInUser) return;

        if (isJoined) {
            // university/major or club/name of major or club
            await axios.post(`/university/${mainTopic}/${subTopicType}/${subtopic}/leave`);
            setLoggedInUser(prev => ({
                ...prev,
                joinedSubtopics: prev.joinedSubtopics.filter(t => t !== topicName)
            }));
        } else {
            await axios.post(`/university/${mainTopic}/${subTopicType}/${subtopic}/join`);
            setLoggedInUser(prev => ({
                ...prev,
                joinedSubtopics: [...prev.joinedSubtopics, topicName]
            }));
        }
    };

    useEffect(() => {
        posts.forEach(post => {
            console.log(post.topicType);
        });
    }, [posts]);

    const location = useLocation();
    const navItems = [
      { label: "Popular Academia", path: "/mainsocial/academia/popular" },
      //{ label: "University", path: "/topics" },
      {
            label: "University",
            path: "/mainsocial/academia/university",
            matchPaths: [
            "/topics",
            "/mainsocial/academia/university"
            ]
        },
      { label: "Academic Subjects", path: "/mainsocial/academia/academicsubjects" },
    ];

    const getButtonStyles = (item) => {
      //const active = location.pathname.startsWith(path);
      const active = item.matchPaths
        ? item.matchPaths.some(path => location.pathname.startsWith(path))
        : location.pathname.startsWith(item.path);

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
    return (
        <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >
        {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      //sx={getButtonStyles(item.path)}
                      sx={getButtonStyles(item)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
            {/*<Box 
                display="flex" 
                onClick={() => history.push(`/topics/${mainTopic}`)}
                justifyContent="center" 
                mt={2} 
                mb={2}
                sx={{
                       cursor: "pointer",
                }}
            >
                <img 
                    src={universityLogo} 
                    alt={mainTopic}
                    style={{
                        maxWidth: "300px",   // limit width
                        height: "auto",      // keep proportions
                        objectFit: "contain" // avoid stretching
                    }}
                />
            </Box>*/}
            <Box 
                display="flex" 
                justifyContent="center" 
                mt={2} 
                mb={2}
            >
                <Typography variant="h4">c/{mainTopic}/{subtopic}</Typography>
            </Box>
            <Box display="flex" justifyContent="center" gap={2} mb={3}>
                <Button variant="outlined" onClick={handleMenuOpen}>
                    {menuLabel}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => handleMenuClose(null)}
                    >
                    {/* Popular option */}
                    {/*<MenuItem
                        onClick={() =>
                        handleMenuClose(defaultLabel, "popular")
                        }
                    >
                        {defaultLabel}
                    </MenuItem>*/}
                    <MenuItem
                        onClick={() =>
                            handleMenuClose(`Popular ${decodeURIComponent(mainTopic)}/${decodeURIComponent(subtopic)}`, "popular")
                        }
                    >
                        Popular {decodeURIComponent(mainTopic)}/{decodeURIComponent(subtopic)}
                    </MenuItem>

                    {/* Recent option */}
                    {/*<MenuItem
                        onClick={() =>
                        handleMenuClose("Recent", "recent")
                        }
                    >
                        Recent
                    </MenuItem>*/}
                    <MenuItem
                        onClick={() =>
                            handleMenuClose(`Recent ${decodeURIComponent(mainTopic)}/${decodeURIComponent(subtopic)}`, "recent")
                        }
                    >
                        Recent {decodeURIComponent(mainTopic)}/{decodeURIComponent(subtopic)}
                    </MenuItem>
                    <MenuItem
                        onClick={() =>
                        handleMenuClose("Cracked", "Cracked")
                        }
                    >
                        Cracked
                    </MenuItem>
                </Menu>
                {/*<Button 
                    variant="outlined" 
                    onClick={() => setOpen(true)}
                >
                    Post
                </Button>*/}
                <Button
                    variant={isJoined ? "contained" : "outlined"}
                    onClick={toggleJoinSubtopic}
                >
                    {isJoined ? "Joined" : "Join"}
                </Button>
            </Box>
            {/*
            <Typography variant="h4">{decodeURIComponent(mainTopic)}/{subTopicType}/{decodeURIComponent(subtopic)}</Typography>

            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={() => setOpen(true)}
            >
                Create Post
            </Button>
            */}

            {/* Dialog for creating post */}
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Create a Post for {decodeURIComponent(mainTopic)}/{subTopicType}/{decodeURIComponent(subtopic)}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Title"
                        fullWidth
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Content"
                        fullWidth
                        multiline
                        rows={4}
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={handleSubmit} variant="contained">Submit</Button>
                </DialogActions>
            </Dialog>

            <Box
                  p={2} // padding inside box
                  my={2} // vertical margin between posts
                  border="1px solid #ccc" // light grey border
                  borderRadius="8px" // rounded corners
                  sx={{
                      position: "relative",
                      maxWidth: 900, // limit width
                      mx: "auto", // center horizontally
                      my: 2, // vertical spacing between each post
                  }}
              >
              <TextField
                  fullWidth
                  multiline
                  rows={2}
                  placeholder="Pause. Muse — and write..."
                  value={content} 
                  //value={newComment}
                  //onChange={e => setNewComment(e.target.value)}
                  onChange={(e) => setContent(e.target.value)} 
              />
              <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmit}>
                  Submit Post
              </Button>
              </Box>

                {/** render each post in topic */}
                {posts.map((post, idx) => {
                    const isLast = idx === posts.length - 1;

                    return (
                        <Box
                        key={post._id}
                        ref={isLast ? lastPostRef : null}
                        onClick={() => history.push(`/post/${post._id}/comments`)}
                        border="1px solid #ccc" // light border
                        borderRadius="6px" // rounded corners
                        p={2} // padding inside
                        my={2} // margin top and bottom
                        //position="relative"
                        sx={{ 
                            position: "relative", 
                            maxWidth: 900, // limit width 
                            mx: "auto", // center horizontally
                            my: 2, // vertical spacing between each post
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#f9f9f9"
                            }
                        }}
                    >

                        {/*
                        <Typography variant="subtitle2">@{post.author.username}</Typography>

                        <Typography>{post.title}</Typography>

                        <Typography>{post.content}</Typography>

                        <Typography variant="caption">
                            {new Date(post.created_at).toLocaleString()}
                        </Typography>
                        */}
                        <Box display="flex" alignItems="flex-start" gap={1}>
                            <Avatar
                            src={post.author?.profileImageUrl || '/default-avatar.jpg'}
                            alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
                            onClick={(e) => visitProfile(e, post.author?._id)}
                            sx={{ 
                                width: 62, 
                                height: 62,
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: "#d9e4f0",
                                }, 
                                }}
                            />
                            <Box>
                            <Typography variant="subtitle1" fontWeight="bold"
                            onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                            >
                                {post.author?.first_name && post.author?.last_name
                                ? `${post.author.first_name} ${post.author.last_name}`
                                : 'Unknown Name'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary"
                            onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                            >
                                @{post.author?.username || 'unknown'}
                            </Typography>
                            
                            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                {post.title}
                            </Typography>

                            {/* Post content */}
                            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                {post.content}
                            </Typography>

                            {/* Date */}
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                            >
                                {`${new Date(post.created_at).toLocaleString()}, ${
                                    post.commentCount
                                } ${post.commentCount === 1 ? "reply" : "replies"}`}
                            </Typography>
                            </Box>
                        </Box>

                        {/* Upvote Button */}
                        {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                            <Button
                            size="small"
                            variant={post.voted ? "contained" : "outlined"}
                            //onClick={() => toggleVote(post._id)}
                            onClick={(e) => {
                                  e.stopPropagation();  
                                  toggleVote(post._id)}
                                }
                            >
                            ▲ {post.voted ? "Unvote" : "Upvote"}
                            </Button>
                            <Typography variant="body2">{post.upvotes} upvotes</Typography>
                        </Box>*/}
                        <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {post.voted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleVote(post._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleVote(post._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{post.upvotes} Power Votes</Typography>
                    </Box>

                        {/** view comments */}
                        {/*<Button
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1 }}
                            onClick={() => history.push(`/post/${post._id}/comments`)}
                            >
                            View Comments
                        </Button>*/}
                    </Box>
                );
                })}
                {/*}
                {posts.length === 0 ? (
                    <Typography>No posts yet for {decodeURIComponent(subtopic)}</Typography>
                ) : (
                    posts.map((post) => (
                        <Box key={post._id} p={2} mb={2} border="1px solid #ccc" borderRadius="6px">
                            <Typography variant="h6">{post.title}</Typography>
                            <Typography>{post.content}</Typography>
                        </Box>
                    ))
                )}
                */}
 
    </div>
    );
}

export default SubTopicPage;